import { NavLink } from "react-router-dom";
import { FileQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";
import PageHeader from "@/components/layout/PageHeader";
import EmptyState from "@/components/ui/EmptyState";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        title={t("pages.notFound.pageHeaderTitle")}
        description={t("pages.notFound.pageHeaderDescription")}
      />
      <div className="px-6 py-6">
        <EmptyState
          icon={FileQuestion}
          title={t("pages.notFound.emptyStateTitle")}
          description={t("pages.notFound.emptyStateDescription")}
          action={
            <NavLink
              to="/"
              className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-ink hover:bg-primary-dark"
            >
              {t("pages.notFound.backToDashboardLink")}
            </NavLink>
          }
        />
      </div>
    </>
  );
}
